import React, { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { ErDuHerModal } from "./ErDuHerModal";
import { loggUt } from "./auth.utils";

export default function IdleTimer({ children }: { children: React.ReactNode }) {
  // Idle timer config
  const minuttIMillisekunder = 60000;
  const timeoutIMillisekunder = minuttIMillisekunder * 9;
  const promptBeforeIdleIMillisekunder = minuttIMillisekunder * 2;

  const [open, setOpen] = useState(false);

  const onPrompt = () => {
    setOpen(true);
  };

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { activate } = useIdleTimer({
    timeout: timeoutIMillisekunder,
    promptBeforeIdle: promptBeforeIdleIMillisekunder,
    onIdle: () => loggUt(true),
    onPrompt: onPrompt,
  });

  const handleStillHere = () => {
    activate();
    setOpen(false);
  };

  return (
    <>
      <ErDuHerModal isOpen={open} handleStillHere={handleStillHere} />
      {children}
    </>
  );
}
